/* ==========================================================================
   Ryse - Theoric: cupom de desconto na gaveta do carrinho

   ===========================  O QUE EU DESCOBRI  ===========================
   Testado na loja com o cupom real BEMVINDO10 (10%):

   1. POST /cart/update.js { discount: "CODIGO" } aplica via Ajax.
      Medido: 996,00 -> 896,40, e o desconto aparece por linha em item.discounts.
   2. POST /cart/update.js { discount: "" } remove.

   3. >>> CUPOM INVALIDO NAO DA ERRO. <<<
      A Shopify devolve status 200 e IGNORA o codigo, em silencio. Se a gente
      confiar no status HTTP, o cliente digita errado, aperta "Aplicar", e nada
      acontece - sem entender por que.
      Por isso, depois de aplicar, CONFERIMOS se o codigo entrou de fato em
      cart_level_discount_applications. Ver validar().

   AVISO DE MANUTENCAO: o parametro `discount` do /cart/update.js NAO e
   documentado pela Shopify. Funciona hoje. Se parar, o caminho de reserva e
   navegar para /discount/CODIGO (tambem testado), ao custo de recarregar.
   ==========================================================================

   >>> SEM RENDERCONTENTS <<<
   A versao anterior pedia `sections` no POST e mandava a gaveta se redesenhar
   inteira. Isso demolia o DOM e era a origem das "piscadas". Agora o pedido vai
   por TheoricCart.definirCupom(), que nao pede secao nenhuma: os modulos
   recebem o carrinho novo e pintam os valores no lugar.

   ESTADOS
   FECHADO  -> so o link "Possui cupom?"
   ABERTO   -> o campo (icone + input + Aplicar)
   APLICADO -> o campo com o chip verde "-10% x", em so leitura

   O bloco nasce FECHADO: campo de cupom sempre visivel e um dos maiores ladroes
   de conversao que existem - quem NAO tem cupom ve a caixa, entende que ha
   desconto em algum lugar, e sai da loja para cacar um. Muitos nao voltam.
   EXCECAO: se o carrinho JA chega com cupom, o bloco nasce ABERTO. Esconder um
   desconto que ja esta valendo deixaria o cliente sem entender por que o total
   caiu - e desconfianca com o valor e o pior lugar para economizar um clique.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.TheoricCart;
  if (!T) {
    console.error('[theoric-cupom] theoric-cart-core.js nao carregou.');
    return;
  }

  var ICONE_TICKET =
    '<svg class="theoric-cupom__icone" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/>' +
    '<path d="M13 5v2M13 11v2M13 17v2"/></svg>';

  var ICONE_X =
    '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';

  function rodape() { return document.querySelector('.theoric__footer-inner'); }

  /* --- o que o chip mostra: "-10%" ou "-R$ 50,00" --- */
  function rotuloDoCupom(cupom) {
    if (cupom.value_type === 'percentage') {
      var n = parseFloat(cupom.value); // a Shopify manda "10.0"
      return '-' + (n % 1 === 0 ? n.toFixed(0) : String(n)) + '%';
    }
    return '-' + T.moeda(cupom.total_allocated_amount);
  }

  /* ========================================================================== */
  function montar() {
    var alvo = rodape();
    if (!alvo) return null;

    var existente = alvo.querySelector('[data-theoric-cupom]');
    if (existente) return existente;

    var bloco = document.createElement('div');
    bloco.className = 'theoric-cupom';
    bloco.setAttribute('data-theoric-cupom', '');

    bloco.innerHTML =
      '<button type="button" class="theoric-cupom__abrir" data-cupom-abrir aria-expanded="false">' +
        ICONE_TICKET + '<span>Possui cupom?</span>' +
      '</button>' +
      '<div class="theoric-cupom__campo">' +
        ICONE_TICKET +
        '<input type="text" class="theoric-cupom__input" data-cupom-input ' +
          'placeholder="Digite seu cupom" autocomplete="off" ' +
          'aria-label="Código do cupom de desconto">' +
        '<button type="button" class="theoric-cupom__aplicar" data-cupom-aplicar>' +
          '<span data-cupom-aplicar-rotulo>Aplicar</span>' +
        '</button>' +
        '<span class="theoric-cupom__chip" data-cupom-chip>' +
          '<span data-cupom-rotulo></span>' +
          '<button type="button" class="theoric-cupom__remover" data-cupom-remover ' +
            'aria-label="Remover cupom">' + ICONE_X + '</button>' +
        '</span>' +
      '</div>' +
      '<p class="theoric-cupom__erro" data-cupom-erro role="alert"></p>';

    alvo.insertBefore(bloco, alvo.firstChild);
    ligar(bloco);
    return bloco;
  }

  /* --- pinta o estado. NAO reconstroi. --- */
  function pintar(carrinho) {
    if (!carrinho || !carrinho.item_count) return;

    var bloco = montar();
    if (!bloco) return;

    var ativos = T.cuponsAtivos(carrinho);
    var input = bloco.querySelector('[data-cupom-input]');
    var chip = bloco.querySelector('[data-cupom-chip]');

    if (ativos.length) {
      var cupom = ativos[0];
      var eNovo = !bloco.classList.contains('has-cupom');

      bloco.classList.add('has-cupom');
      bloco.classList.remove('has-error', 'has-texto');
      bloco.querySelector('[data-cupom-rotulo]').textContent = rotuloDoCupom(cupom);
      input.value = cupom.title;
      input.readOnly = true;

      // o chip so "nasce" (anima) quando acaba de aparecer - nao a cada pintura
      if (eNovo) {
        chip.classList.remove('is-novo');
        void chip.offsetWidth;
        chip.classList.add('is-novo');
      }
    } else {
      bloco.classList.remove('has-cupom');
      chip.classList.remove('is-novo');
      bloco.querySelector('[data-cupom-rotulo]').textContent = '';
      input.readOnly = false;
      if (input.value.trim()) bloco.classList.add('has-texto');
    }
  }

  function erro(bloco, mensagem) {
    bloco.classList.add('has-error');
    bloco.querySelector('[data-cupom-erro]').textContent = mensagem;
  }

  function limparErro(bloco) {
    bloco.classList.remove('has-error');
    bloco.querySelector('[data-cupom-erro]').textContent = '';
  }

  /* --------------------------------------------------------------------------
     A CHECAGEM QUE NAO PODE FALTAR
     A Shopify aceita cupom invalido em silencio (200, nenhum efeito). NAO
     confiamos no status: perguntamos ao carrinho se o codigo entrou mesmo.
     -------------------------------------------------------------------------- */
  function validar(codigo, carrinho) {
    var alvo = String(codigo).trim().toUpperCase();
    return T.cuponsAtivos(carrinho).some(function (d) {
      return String(d.title).trim().toUpperCase() === alvo;
    });
  }

  function aplicar(bloco) {
    var input = bloco.querySelector('[data-cupom-input]');
    var botao = bloco.querySelector('[data-cupom-aplicar]');
    var rotulo = bloco.querySelector('[data-cupom-aplicar-rotulo]');
    var codigo = input.value.trim();

    if (!codigo) { input.focus(); return; }

    limparErro(bloco);
    botao.disabled = true;
    bloco.classList.add('is-carregando');
    rotulo.textContent = 'Aplicando';

    T.definirCupom(codigo)
      .then(function (carrinho) {
        if (!validar(codigo, carrinho)) {
          // a API disse 200, mas o cupom nao entrou
          erro(bloco, 'Cupom inválido, expirado ou não aplicável a estes produtos.');
          input.select();
        }
        // se entrou, o pintar() do proprio modulo ja cuidou do resto -
        // ele foi chamado pelo TheoricCart.definirCupom()
      })
      .catch(function (e) {
        console.error('[theoric-cupom] falha ao aplicar.', e);
        erro(bloco, 'Não foi possível aplicar agora. Tente de novo.');
      })
      .finally(function () {
        botao.disabled = false;
        bloco.classList.remove('is-carregando');
        rotulo.textContent = 'Aplicar';
      });
  }

  function remover(bloco) {
    var botao = bloco.querySelector('[data-cupom-remover]');
    botao.disabled = true;
    bloco.classList.add('is-carregando');

    T.definirCupom('')
      .then(function () {
        var input = bloco.querySelector('[data-cupom-input]');
        input.value = '';
        input.readOnly = false;
        // volta ao FECHADO: sem cupom, o campo nao precisa ficar a mostra
        bloco.classList.remove('has-cupom', 'has-texto', 'is-open');
      })
      .catch(function (e) {
        console.error('[theoric-cupom] falha ao remover.', e);
      })
      .finally(function () {
        botao.disabled = false;
        bloco.classList.remove('is-carregando');
      });
  }

  /* ========================================================================== */
  function ligar(bloco) {
    var input = bloco.querySelector('[data-cupom-input]');
    var abrir = bloco.querySelector('[data-cupom-abrir]');

    abrir.addEventListener('click', function () {
      bloco.classList.add('is-open');
      abrir.setAttribute('aria-expanded', 'true');

      /* ARMADILHA JA PAGA: focar o input NA MESMA LINHA em que se troca a classe
         nao funciona - o campo ainda esta em display:none, e nao se da foco no
         que nao existe na tela. No celular isso custava um toque a mais: a
         pessoa clicava em "Possui cupom?", o campo abria, e ela tinha que tocar
         nele de novo para o teclado subir. */
      var focar = function () { input.focus(); };
      requestAnimationFrame(function () { requestAnimationFrame(focar); });
      setTimeout(focar, 80);
    });

    bloco.querySelector('[data-cupom-aplicar]')
      .addEventListener('click', function () { aplicar(bloco); });

    bloco.querySelector('[data-cupom-remover]')
      .addEventListener('click', function () { remover(bloco); });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); aplicar(bloco); }
    });

    // o "Aplicar" so aparece quando ha algo digitado - senao fica ali, sozinho,
    // convidando a um clique que nao faz nada
    input.addEventListener('input', function () {
      limparErro(bloco);
      bloco.classList.toggle('has-texto', !!input.value.trim());
    });
  }

  /* ========================================================================== */
  T.ao(pintar);
})();
